export default {
  Titulo: "Habite-se",
  Campos: {
    NumeroProjeto: {
      Tipo: 'text',
      Label: 'Número Projeto',
      Tooltip: 'Número Projeto',
      Placeholder: 'Número Projeto',
      Obrigatorio: true,
    },
    AnoProjeto: {
      Tipo: 'number',
      Label: 'Ano Projeto',
      Tooltip: 'Ano Projeto',
      Placeholder: 'Ano Projeto',
      Tamanho: 4,
      Obrigatorio: true,
    },
    NumeroHabitese: {
      Tipo: 'text',
      Label: 'Número Habite-se',
      Tooltip: 'Número Habite-se',
      Placeholder: 'Número Habite-se',
      Obrigatorio: true,
    },
    DataEmissaoHabitese: {
      Tipo: 'date',
      Tooltip: 'Data Emissão Habite-se',
      Label: 'Data Emissão Habite-se',
      Obrigatorio: true,
    },
    // Dados Habitese
    Protocolo: {
      Tipo: 'text',
      Label: 'Protocolo',
      Tooltip: 'Protocolo',
      Placeholder: 'Protocolo',
    },
    Processo: {
      Tipo: 'text',
      Label: 'Processo',
      Tooltip: 'Processo',
      Placeholder: 'Processo',
    },
    Projeto: {
      Tipo: 'text',
      Label: 'Projeto',
      Tooltip: 'Projeto',
      Placeholder: 'Projeto',
    },
    DataInicioObra: {
      Tipo: 'date',
      Tooltip: 'Data Início Obra',
      Label: 'Data Início Obra',
    },
    Solicitante: {
      Tipo: 'text',
      Tooltip: 'Solicitante',
      Label: 'Solicitante',
      Placeholder: 'Solicitante',
    },
    ResponsavelProjeto: {
      Tipo: 'text',
      Tooltip: 'Profissional Responsável pelo Projeto',
      Label: 'Profissional Responsável pelo Projeto',
      Placeholder: 'Profissional Responsável pelo Projeto',
    },
    ArtProjeto: {
      Tipo: 'text',
      Label: 'ART',
      Tooltip: 'ART',
      Placeholder: 'ART',
    },
    RrtProjeto: {
      Tipo: 'text',
      Label: 'RRT',
      Tooltip: 'RRT',
      Placeholder: 'RRT',
    },
    ResponsavelExecucao: {
      Tipo: 'text',
      Tooltip: 'Profissional Responsável pela Execução',
      Label: 'Profissional Responsável pela Execução',
      Placeholder: 'Profissional Responsável pela Execução',
    },
    ArtExecucao: {
      Tipo: 'text',
      Label: 'ART',
      Tooltip: 'ART',
      Placeholder: 'ART',
    },
    RrtExecucao: {
      Tipo: 'text',
      Label: 'RRT',
      Tooltip: 'RRT',
      Placeholder: 'RRT',
    },
    TipoHabitese: {
      Tipo: 'combobox',
      Label: 'Tipo',
      Tooltip: 'Tipo',
      itens: [
        { Texto: 'Parcial', Valor: 1 },
        { Texto: 'Total', Valor: 2 }
      ],
    },
    AlvaraReferente: {
      Tipo: 'text',
      Label: 'Referente ao Alvará',
      Tooltip: 'Referente ao Alvará',
      Placeholder: 'Referente ao Alvará',
    },
    Proprietario: {
      Tipo: 'text',
      Tooltip: 'Proprietário',
      Label: 'Proprietário',
      Placeholder: 'Proprietário',
    },
  }
};
